<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 flex justify-between mb-6">
      <span class="text-[#2d82b5] font-semibold">
        SAT for {{ infoStudent.fullName }}
      </span>
      <span class="text-sm">
        {{ $t("common.student_id") }}:
        <span class="font-semibold">{{ infoStudent.studentCode }}</span>
        <span class="ml-4">
          {{ $t("common.grade") }}:
          <span class="font-semibold">{{ infoStudent.grade }}</span>
        </span>
      </span>
    </div>

    <div class="md-layout-item md-size-100 mb-3">
      <chart :chartData="chartData"></chart>
    </div>

    <div class="md-layout-item md-size-100">
      <div class="flex justify-between mb-3">
        <span class="font-medium">
          {{ $t("smi_sri.detail_about_tests") }}
        </span>
        <span class="text-right text-red-600 text-sm">
          {{ $t("smi_sri.super_score") }}:
          <span class="font-medium">{{ superScore }}</span>
        </span>
      </div>
      <md-table class="table-pdf-assessment">
        <md-table-row class="text-center">
          <md-table-cell>
            {{ $t("smi_sri.test_name") }}
          </md-table-cell>
          <md-table-cell>{{ $t("smi_sri.test_date") }}</md-table-cell>
          <md-table-cell>
            <div>
              {{ $t("smi_sri.total_score_1600") }}
            </div>
          </md-table-cell>
          <md-table-cell>Reading and Writing (200-800)</md-table-cell>
          <md-table-cell>
            Math (200 - 800)
          </md-table-cell>
        </md-table-row>
        <md-table-row
          class="text-center"
          v-for="(info, index) in tableData"
          :key="info + index"
        >
          <md-table-cell>{{ info.test_name }}</md-table-cell>
          <md-table-cell
            >{{ convertDateFromServer(info.test_date, "date") }}
          </md-table-cell>
          <md-table-cell>{{ info.total_score }}</md-table-cell>
          <md-table-cell>{{ info.reading_and_writing }}</md-table-cell>
          <md-table-cell>{{ info.math }}</md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
import Chart from "./Chart";
import { convertDateFromServer } from "@/helpers/datetime-helper";

export default {
  name: "export-pdf-sat",
  components: { Chart },
  props: ["infoStudent", "chartData", "tableData", "superScore"],
  data() {
    return {
      convertDateFromServer
    };
  }
};
</script>
